import { instance, next } from "./base";

export const getUsers = async ({ page, limit, search }) => {
  const { data } = await instance()
    .get("/api/v1/admin/users", { params: { page, limit, ...(search && { search }) } })
    .catch((e) => next(e));
  return data?.data;
};

export const getUserMetrics = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/users/metrics")
    .catch((e) => next(e));
  return data?.data;
};

export const getUserDetail = async (id) => {
  const { data } = await instance()
    .get(`/api/v1/admin/users/${id}`)
    .catch((e) => next(e));
  return data?.data;
};

export const manageUserStatus = async (values) => {
  const id = values.id;
  delete values.id;
  const { data } = await instance()
    .patch(`/api/v1/admin/users/${id}/status`, values)
    .catch((e) => next(e));
  return data?.data;
};
export const setUserRisk = async ({ id, level, note }) => {
  const { data } = await instance()
    .patch(`/api/v1/admin/users/${id}/risk`, { level, note })
    .catch((e) => next(e));
  return data?.data;
};

// one billed Prembly lookup; bvn is optional (defaults to the one on file)
export const verifyUserBvn = async ({ id, bvn }) => {
  const { data } = await instance()
    .post(`/api/v1/admin/users/${id}/verify-bvn`, bvn ? { bvn } : {})
    .catch((e) => next(e));
  return data;
};
